import { TemplateEditViews } from '../common/types';
import { useQueryParamContext } from '../context/QueryParamContext';
import { PushContext } from './context/PushContext';
import PreviewWithData from './PreviewWithData';
import Settings from './Settings';

const renderView = (view: string) => {
  switch (view) {
    case TemplateEditViews.preview:
      return <PreviewWithData />;
    default:
      return <Settings />;
  }
};

export const EditPush = () => {
  const { view } = useQueryParamContext();

  return <PushContext>{renderView(view)}</PushContext>;
};

export default EditPush;
